module.exports = __webpack_public_path__ + "img/equipo_16-9_1440.f0d4b377.webp";